import {updatedAllProspectsSearchTerm, updatedSavedProspectsSearchTerm} from '../../store/search/searchSlice'
import {
  getAllProspectsData,
  getAllSavedProspectsData
} from '../../store/prospectSegment/allProspectsData/allProspectsDataSlice'
import {getProspectsPageNumber, getSavedProspectsPageNumber} from '../../store/pagination/pageNumberSlice'

export const selectSearchTerm = [
  {contentKey: 'savedProspects', selectorContent: 'savedProspectsSearch'},
  {contentKey: 'allProspects', selectorContent: 'allProspectsSearch'}
]

export const dispatchSearchTerm = [
  {contentKey: 'savedProspects', selectorContent: updatedSavedProspectsSearchTerm},
  {contentKey: 'allProspects', selectorContent: updatedAllProspectsSearchTerm}
]

export const updateTableData = [
  {contentKey: 'savedProspects', selectorContent: getAllSavedProspectsData},
  {contentKey: 'allProspects', selectorContent: getAllProspectsData}
]

export const updateTablePageNumber = [
  {contentKey: 'savedProspects', selectorContent: getSavedProspectsPageNumber},
  {contentKey: 'allProspects', selectorContent: getProspectsPageNumber}
]
